import { call, put, takeEvery, fork, all } from 'redux-saga/effects';
import axios from 'axios';




function * createSavedFilterAsync(data){
  try{
    const api = yield call([axios, axios.post], '/api/saved_filters', data.payload)
    yield put({type:'REQUEST_CREATE_SAVED_FILTER_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'SET_SNACKBAR', val:{open:true, message:'An error occurred.', type:'error'}});
  }
}

function * updateSavedFilterAsync(data){
  try{
    const api = yield call([axios, axios.put], '/api/saved_filters/'+data.id, data.payload)
    yield put({type:'REQUEST_UPDATE_SAVED_FILTER_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'SET_SNACKBAR', val:{open:true, message:'An error occurred.', type:'error'}});
  }
}

function * indexSavedFiltersAsync(data){
  try{
    const api = yield call([axios, axios.get], '/api/saved_filters')
    yield put({type:'REQUEST_INDEX_SAVED_FILTERS_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'SET_SNACKBAR', val:{open:true, message:'An error occurred.', type:'error'}});
  }
}



function* createTableColumnOrderAsync(data) {
  try {
    const api = yield call([axios, axios.post], '/api/table_column_orders', data.payload)
    yield put({ type: 'REQUEST_CREATE_TABLE_COLUMN_ORDER_SUCCESS', val: api.data });
  } catch (error) {
    console.log(error, 'ERROR');
    yield put({ type: 'SET_SNACKBAR', val: { open: true, message: 'An error occurred.', type: 'error' } });
  }
}

function* updateTableColumnOrderAsync(data) {
  try {
    const api = yield call([axios, axios.put], '/api/table_column_orders/' + data.id, data.payload)
    yield put({ type: 'REQUEST_UPDATE_TABLE_COLUMN_ORDER_SUCCESS', val: api.data });
  } catch (error) {
    console.log(error, 'ERROR');
    yield put({ type: 'SET_SNACKBAR', val: { open: true, message: 'An error occurred.', type: 'error' } });
  }
}

function* indexTableColumnOrdersAsync(data) {
  try {
    const api = yield call([axios, axios.get], '/api/table_column_orders')
    yield put({ type: 'REQUEST_INDEX_TABLE_COLUMN_ORDERS_SUCCESS', val: api.data });
  } catch (error) {
    console.log(error, 'ERROR');
    yield put({ type: 'SET_SNACKBAR', val: { open: true, message: 'An error occurred.', type: 'error' } });
  }
}


function* Create_saved_filter(){yield takeEvery('REQUEST_CREATE_SAVED_FILTER', createSavedFilterAsync);}
function* Update_saved_filter(){yield takeEvery('REQUEST_UPDATE_SAVED_FILTER', updateSavedFilterAsync);}
function* Index_saved_filters(){yield takeEvery('REQUEST_INDEX_SAVED_FILTERS', indexSavedFiltersAsync);}

function* Create_table_column_order() { yield takeEvery('REQUEST_CREATE_TABLE_COLUMN_ORDER', createTableColumnOrderAsync); }
function* Update_table_column_order() { yield takeEvery('REQUEST_UPDATE_TABLE_COLUMN_ORDER', updateTableColumnOrderAsync); }
function* Index_table_column_orders() { yield takeEvery('REQUEST_INDEX_TABLE_COLUMN_ORDERS', indexTableColumnOrdersAsync); }


export default function* Root_saved_filters(){
  yield all([
    fork(Create_saved_filter),
    fork(Update_saved_filter),
    fork(Index_saved_filters),

    fork(Create_table_column_order),
    fork(Update_table_column_order),
    fork(Index_table_column_orders)
  ])}
